export default "__VITE_ASSET__1d25eb22__"